module.exports = __webpack_public_path__ + "img/content1.0a74b494.png";